import React from 'react';

// Shared star icon for every "pinned" indicator across the app. One
// component, one shape, one brand colour — replaces the emoji
// pushpin (📌) that rendered as pink on one browser / green on
// another (emoji are font-rendered by the OS, not styleable), plus
// the legacy pushpin SVGs that lived inline on the Pinned page +
// dashboard Pinned widgets.
//
// State rule (per the 2026-06 pin-icon-sweep brief):
//   filled  (Fusion green #92D400) — the item IS pinned.
//   outline (mid-grey #7d7f76 / configurable) — pinnable but not
//                                                pinned. Used ONLY on
//                                                list rows where items
//                                                can be in either
//                                                state.
// Surfaces that only show already-pinned items (the Pinned page
// cards, the dashboard Pinned widgets) always pass filled — the fill
// carries meaning, it isn't decorative.
//
// The polygon points match the PinButton burst-animation source
// (components/pinBurst/PinButton.js STAR_POINTS) so the shape stays
// pixel-identical across toggle-burst, header pill, list-row icon,
// and the dashboard / Pinned-page indicators.

export const STAR_POINTS = '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2';

export default function StarIcon({
  filled = true,
  size = 14,
  className = '',
  // Override colour only when the surface needs a non-green star (e.g.
  // a list-row outline in mid-grey). Default green (#92D400) carries
  // the Fusion brand signal for "pinned."
  color,
}) {
  const fg = color || '#92D400';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? fg : 'none'}
      stroke={fg}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}>
      <polygon points={STAR_POINTS} />
    </svg>
  );
}
